import type { ValueOf } from 'cpool-utils';

export const ButtonVariant = {
    PRIMARY: 'primary',
    PRIMARY_OUTLINE: 'primary-outline',
    SECONDARY: 'secondary',
    SECONDARY_DARK: 'secondary-dark',
} as const;

export type ButtonVariantType = ValueOf<typeof ButtonVariant>;
